import { FormService } from "@swan/api"; //eslint-disable-line

export default FormService;
